<script lang="ts">
  export let color;
</script>

<div class="concierge-chat-logo-loader-container">
  <svg
    width="250"
    height="250"
    viewBox="0 0 250 250"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M167.702 82.6344L125.643 40.6937C108.951 24.0488 81.9265 24.0869 65.2816 40.7787L24.0297 82.1468L33.5738 91.6641L74.8257 50.296C86.2144 38.8753 104.705 38.8493 116.126 50.2379L158.185 92.1786L160.203 90.1544C158.029 94.7952 158.863 100.495 162.701 104.322C167.593 109.2 175.514 109.189 180.392 104.297C185.271 99.4048 185.259 91.4842 180.367 86.6058C176.529 82.7785 170.827 81.9607 166.193 84.1481L167.702 82.6344ZM184.387 208.897L226.668 166.497L225.975 165.806C230.376 167.348 235.466 166.356 238.979 162.833C243.857 157.941 243.846 150.021 238.954 145.142C234.062 140.264 226.141 140.275 221.263 145.167C217.75 148.69 216.772 153.782 218.327 158.179L217.124 156.979L174.843 199.38C163.454 210.8 144.963 210.827 133.543 199.438L92.49 158.501L82.9727 168.045L124.025 208.982C140.717 225.627 167.742 225.589 184.387 208.897ZM168.048 166.643L208.955 125.622C225.6 108.93 225.562 81.9051 208.87 65.2602L167.841 24.3473L158.324 33.8915L199.352 74.8044C210.773 86.193 210.799 104.684 199.411 116.104L158.504 157.126L168.048 166.643ZM82.6315 82.0188L40.7169 124.051C24.072 140.743 24.1101 167.768 40.8019 184.413L83.0058 226.498L84.139 225.362C82.261 229.902 83.1714 235.322 86.8667 239.007C91.7589 243.885 99.6795 243.874 104.558 238.982C109.436 234.09 109.425 226.169 104.533 221.291C100.838 217.606 95.4147 216.711 90.8799 218.602L92.5231 216.954L50.3192 174.869C38.8985 163.48 38.8725 144.99 50.2611 133.569L92.1756 91.5361L90.0859 89.4523C94.7423 91.6783 100.49 90.8581 104.341 86.996C109.219 82.1039 109.208 74.1832 104.316 69.3048C99.4237 64.4264 91.5031 64.4375 86.6246 69.3297C82.7734 73.1918 81.9694 78.9413 84.2085 83.5914L82.6315 82.0188ZM10.7131 104.533C15.6052 109.412 23.5259 109.401 28.4043 104.509C33.2827 99.6164 33.2716 91.6957 28.3794 86.8173C23.4872 81.9389 15.5666 81.9501 10.6882 86.8422C5.80972 91.7344 5.82088 99.6551 10.7131 104.533ZM86.9677 145.354C82.0755 140.475 74.1548 140.487 69.2764 145.379C64.398 150.271 64.4091 158.192 69.3013 163.07C74.1935 167.948 82.1141 167.937 86.9926 163.045C91.871 158.153 91.8598 150.232 86.9677 145.354ZM145.328 162.677C140.45 167.569 140.461 175.49 145.353 180.368C150.245 185.247 158.166 185.236 163.045 180.344C167.923 175.451 167.912 167.531 163.02 162.652C158.127 157.774 150.207 157.785 145.328 162.677ZM145.113 10.6874C140.234 15.5796 140.245 23.5002 145.137 28.3787C150.03 33.2571 157.95 33.2459 162.829 28.3538C167.707 23.4616 167.696 15.5409 162.804 10.6625C157.912 5.78409 149.991 5.79525 145.113 10.6874Z"
      stroke={color}
      stroke-width="13.4785"
      stroke-linejoin="round"
    />
  </svg>
</div>

<style>
  .concierge-chat-logo-loader-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    width: 100%;
  }
  .concierge-chat-logo-loader-container > svg {
    width: 25px;
    height: 25px;
    /* animation: slow-rotate 4s infinite; */
  }

  /* @keyframes slow-rotate {
    0% {
      transform: rotate(0deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    15% {
      transform: rotate(180deg);
      animation-timing-function: cubic-bezier(0.14, 0.81, 0.5, 0.97);
    }
    30% {
      transform: rotate(360deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    35% {
      transform: rotate(360deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    40% {
      transform: rotate(405deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    45% {
      transform: rotate(405deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    50% {
      transform: rotate(450deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    55% {
      transform: rotate(450deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    60% {
      transform: rotate(495deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    65% {
      transform: rotate(495deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    70% {
      transform: rotate(540deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    75% {
      transform: rotate(540deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    80% {
      transform: rotate(585deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    85% {
      transform: rotate(585deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }
    90% {
      transform: rotate(630deg);
      animation-timing-function: cubic-bezier(0.67, 0.09, 0.92, 0.49);
    }

    100% {
      transform: rotate(630deg);
    } 
  }*/
</style>
